var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.editingFeeName || !_vm.feeCost.feeName
        ? _c(
            "field",
            {
              attrs: {
                "size-class": "col-3 d-flex flex-column justify-content-center",
                transition: false,
              },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "fee-name",
                  placeholder: _vm.$t("direct-to-lender.fees.feeName"),
                  focus: _vm.editingFeeName,
                  "max-length": 35,
                  "show-max-length-label": "",
                  label: _vm.$t("direct-to-lender.fees.feeName"),
                },
                on: { focusout: _vm.stopEditFeeName, change: _vm.save },
                model: {
                  value: _vm.feeCost.feeName,
                  callback: function ($$v) {
                    _vm.$set(_vm.feeCost, "feeName", $$v)
                  },
                  expression: "feeCost.feeName",
                },
              }),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "col-3 d-flex flex-column justify-content-center" },
            [
              _c(
                "p",
                {
                  staticClass: "grey-text",
                  class: { clickable: !_vm.feeCost.defaultFee },
                  on: { click: _vm.startEditFeeName },
                },
                [_vm._v("\n      " + _vm._s(_vm.feeName) + "\n    ")]
              ),
            ]
          ),
      _vm._v(" "),
      _c(
        "field",
        {
          attrs: {
            "size-class":
              "col-3 d-flex flex-column align-items-center justify-content-center",
            "container-class": "dollar-prepend",
          },
        },
        [
          _c("text-section", {
            attrs: {
              name: "fee-amount",
              placeholder: "0",
              "class-name": "fe-num-field dollar",
              disabled: !_vm.feeCost.amountEditable,
              "allow-minus": "",
              label: _vm.$t("direct-to-lender.commissions.fees.amount"),
            },
            on: { change: _vm.save },
            model: {
              value: _vm.feeCostAmount,
              callback: function ($$v) {
                _vm.feeCostAmount = $$v
              },
              expression: "feeCostAmount",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          attrs: {
            "size-class":
              "col-1 d-flex flex-column align-items-center justify-content-center",
          },
        },
        [
          _c("checkbox-section", {
            attrs: {
              name: "deduct-from-principal",
              "multi-line": false,
              label: _vm.$t("direct-to-lender.fees.deductFromPrincipal"),
              "hidden-label": "",
            },
            on: { change: _vm.save },
            model: {
              value: _vm.feeCost.deductFromPrincipal,
              callback: function ($$v) {
                _vm.$set(_vm.feeCost, "deductFromPrincipal", $$v)
              },
              expression: "feeCost.deductFromPrincipal",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          attrs: {
            "size-class":
              "col-1 d-flex flex-column align-items-center justify-content-center",
          },
        },
        [
          _c("checkbox-section", {
            attrs: {
              name: "include-in-apr",
              "multi-line": false,
              disabled: !_vm.feeCost.includeInAPREditable,
              label: _vm.$t("direct-to-lender.fees.includeInAPR"),
              "hidden-label": "",
            },
            on: { change: _vm.save },
            model: {
              value: _vm.feeCost.includeInAPR,
              callback: function ($$v) {
                _vm.$set(_vm.feeCost, "includeInAPR", $$v)
              },
              expression: "feeCost.includeInAPR",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          attrs: {
            "size-class": "col d-flex flex-column justify-content-center",
          },
        },
        [
          _c("text-section", {
            attrs: {
              name: "fee-comment",
              placeholder:
                "" +
                _vm.$options.filters.capitalize(
                  _vm.$tc("global.words.comment", 2)
                ),
              "max-length": 30,
              "show-max-length-label": "",
              label: _vm.$tc("global.words.comment", 2),
            },
            on: { change: _vm.save },
            model: {
              value: _vm.computedComment,
              callback: function ($$v) {
                _vm.computedComment = $$v
              },
              expression: "computedComment",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.feeCost.defaultFee
        ? _c(
            "div",
            { staticClass: "d-flex flex-column justify-content-center" },
            [
              _c("i", {
                staticClass: "fa fa-trash text-danger clickable",
                on: { click: _vm.removeFeeCost },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }